import React from "react";

function DownloadPrototype({ label, values }) {
  return (
    <div className=" valign-wrapper download-inspection-style pin-top">
      <p className="">{label}</p>
      <span className="vertical-line"></span>
      <p className="">{values}</p>
    </div>
  );
}

export default DownloadPrototype;

